import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};

export type UserTrackingQueryVariables = Exact<{ [key: string]: never }>;

const defaultOptions = {} as const;

export enum EcommerceStatus {
  New = 'new',
  NoPurchases = 'no_purchases',
  Returning = 'returning',
  Unknown = 'unknown',
}

export type UserTrackingQuery = {
  userV2?:
    | { __typename: 'AnonymousUser' }
    | {
        __typename: 'AuthenticatedUser';
        id: string;
        email: string;
        native_id: string;
        first_name?: string | null;
        last_name?: string | null;
        ecommerce_status: EcommerceStatus;
      }
    | null;
};

export const UserTrackingDocument = gql`
  query UserTracking {
    userV2 {
      ... on AuthenticatedUser {
        id
        email
        native_id
        first_name
        last_name
        ecommerce_status
      }
      __typename
    }
  }
`;

/**
 * __useUserTrackingQuery__
 *
 * To run a query within a React component, call `useUserTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTrackingQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTrackingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserTrackingQuery,
    UserTrackingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserTrackingQuery, UserTrackingQueryVariables>(
    UserTrackingDocument,
    options
  );
}
export function useUserTrackingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserTrackingQuery,
    UserTrackingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserTrackingQuery, UserTrackingQueryVariables>(
    UserTrackingDocument,
    options
  );
}
export type UserTrackingQueryHookResult = ReturnType<
  typeof useUserTrackingQuery
>;
export type UserTrackingLazyQueryHookResult = ReturnType<
  typeof useUserTrackingLazyQuery
>;
export type UserTrackingQueryResult = Apollo.QueryResult<
  UserTrackingQuery,
  UserTrackingQueryVariables
>;
